import type { ReactNode } from 'react';
import React from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { RestrictionsDialogStateContainer } from '@confluence/restrictions-dialog-state-container';

import { RestrictionsDialogLoader } from '../RestrictionsDialog/index.tsx';
import { RestrictionsUpsellDialogLoader } from '../RestrictionsUpsellDialog/index.tsx';

import { IsUpsellQueryComponent } from './IsUpsellQueryComponent.tsx';

export type RestrictionsDialogMountPointProps = {
	contentId?: string;
};

export function RestrictionsDialogMountPoint({ contentId }: RestrictionsDialogMountPointProps) {
	return (
		<Subscribe to={[RestrictionsDialogStateContainer]}>
			{(dialogStateContainer: RestrictionsDialogStateContainer) => (
				<IsUpsellQueryComponent contentId={contentId}>
					{({ isUpsell }) => {
						let dialog: ReactNode;

						if (dialogStateContainer.getIsOpen()) {
							const onClose = (callback?: () => void) => {
								void dialogStateContainer.setIsOpen(false, null, callback);
							};

							dialog = isUpsell ? (
								<RestrictionsUpsellDialogLoader onClose={onClose} />
							) : (
								<RestrictionsDialogLoader
									contentId={dialogStateContainer.getContentId()}
									hideSpinner={() => dialogStateContainer.setHideRestrictionsButtonSpinner()}
									onClose={onClose}
								/>
							);
						}

						return <ModalTransition>{dialog}</ModalTransition>;
					}}
				</IsUpsellQueryComponent>
			)}
		</Subscribe>
	);
}
